import React from "react";
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';

const About = ({ language }) => {
  const content = {
    si: {
      title: 'පාරිභෝගිකයින්ට උපදෙස්',
      p1: 'අපගේ වෙබ් අඩවියෙන්, ඔබට ඔබේ අභිමතය පරිදි ඔබේ පරමාදර්ශී මනාලිය හෝ මනාලයා සොයා ගත හැකිය. එක් එක් පැතිකඩ සඳහා "වැඩි විස්තර" කොටස යටතේ ඔවුන්ගේ විස්තර ලබා ගත හැකිය.',
      p2: 'සම්බන්ධතා තොරතුරු ලබා ගැනීම සඳහා, ඔබ වෙබ් අඩවියේ ලියාපදිංචි විය යුතුය. පිවිසීමෙන් පසු, ඔබ ගෙවීමක් කළ යුතුය. අන්තර්ජාල බැංකුකරණය හරහා ගෙවීම් කළ හැකිය, නැතහොත් අපගේ උඩුගත කිරීමේ පෝරමය හරහා ඔබට බැංකු ස්ලිප්පතක් උඩුගත කළ හැකිය. ඔබගේ ලියාපදිංචිය තහවුරු වූ පසු, ඔබට ඔබ කැමති මනාලියගේ හෝ මනාලයාගේ සම්බන්ධතා තොරතුරු ලබා ගත හැක.',
    },
    en: {
      title: 'Advices to the Customers',
      p1: 'From our website, you can search for your ideal bride or groom according to your preferences. Their details are available under the "more details" section for each profile.',
      p2: 'To access contact details, you need to register on the website. After logging in, you will be required to make a payment. Payments can be done via online banking, or you can upload a bank slip through our upload form. Once your registration is confirmed, you can access the contact details of your preferred bride or groom.',
    }
  };

  const t = content[language || 'si'];

  return (
    <React.Fragment>
      <Container maxWidth="lg" sx={{ pt: { xs: 12, md: 15 }, pb: 8 }}>
        <Paper
          elevation={0}
          sx={{
            backgroundColor: 'white',
            p: { xs: 3, md: 6 },
            borderRadius: 2,
            mb: { xs: 10, md: 15 }
          }}
        >
          <h2 style={{ paddingBottom: '1rem' }}>{t.title}</h2>
          <p style={{ lineHeight: 1.8, marginBottom: '1rem' }}>
            {t.p1}
          </p>
          <p style={{ lineHeight: 1.8 }}>
            {t.p2}
          </p>
        </Paper>
      </Container>
    </React.Fragment>
  );
}

export default About;
